export default [
  {
    header: 'ลงทะเบียน',
  },
  {
    title: 'จองคิวศูนย์',
    route: 'addnamelist',
    icon: 'UserPlusIcon',
    role: 'customer', // เฉพาะ customer
  },
  {
    title: 'จองคิวศูนย์ด้วยไฟล์',
    route: 'namelist',
    icon: 'FileIcon',
    role: 'customer',
  },
  {
    title: 'แก้ไขคิวศูนย์',
    route: 'Editnamelist',
    icon: 'EditIcon',
    role: 'customer',
  },
  {
    title: 'อัพเดทคิวด่านชายแดน',
    route: 'search',
    icon: 'RefreshCcwIcon',
    role: 'admin',
    // ไม่มี roles => ทุกคนเห็น
  },
  {
    title: 'แก้ไขข้อมูลแรงงาน',
    route: 'updatenamelist',
    icon: 'EditIcon',
    role: 'admin',
    // ไม่มี roles => ทุกคนเห็น
  },
  {
    header: 'รายงาน',
  },
  {
    title: 'รายงานคิวด่านชายแดน',
    route: 'reportlist',
    icon: 'FileTextIcon',
    role: 'admin',
    //roles: ['admin'], // เฉพาะ admin
  },
  {
    header: 'ตั้งค่า',
  },
  {
    title: 'เพิ่มเจ้าหน้าที่',
    route: 'userlist',
    icon: 'UserPlusIcon',
    titlesToCheck: 'UserID ผู้ใช้งาน',
    // roles: ['admin'],
  },
  {
    title: 'ข้อมูลด่านชายแดน',
    route: 'config',
    icon: 'MapPinIcon',
    titlesToCheck: 'ข้อมูลด่านชายแดน',
    // roles: ['admin'],
  },
  {
    title: 'ข้อมูลศูนย์แรงงานต่างด้าว',
    route: 'workerscenter',
    icon: 'GridIcon',
    titlesToCheck: 'ข้อมูลศูนย์แรงงานต่างด้าว',
    //roles: ['admin'],
  },
]
